module.exports = __webpack_public_path__ + "static/media/top.6bd47ee9.png";